export default __webpack_public_path__ + "static/media/status_hidden.e6909980.svg";